<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-23 
-->
<template>
  <div :class="['fixed-btns', language]">
    <div class="item" v-for="item,index in btnList" :key="index" @click="clickBanner(item, 'right-btn')">
      <img :src="item.img" class="iconfont-wrap" />
      <div class="font">{{item.description}}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  inject: ['clickBanner'],
  props: {
    btnList: {
      default: () => [],
    },
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
  data() {
    return {
      isScroll: false,
    }
  },
  methods: {},
}
</script>
<style lang='stylus' scoped>
.fixed-btns
  position fixed
  width 154px
  right 0
  bottom 190px
  cursor pointer
  z-index 998
  transition all 0.3s
  &.en
    width 160px
    & > div
      .font
        font-size 12px
  & > div
    position relative
    width 100%
    height 50px
    display flex
    align-items center
    background-color #c8161d
    padding 5px 5px 5px 10px
    border-radius 25px 0 0 25px
    transition all 0.3s
    &:hover
      background-color #C8161D
    & + div
      margin-top 10px
    &:before
      content ''
      max-width 10px
      min-width 10px
      height 10px
      border-radius 50%
      background #FFFFFF
    .iconfont-wrap
      max-width 24px
      min-width 24px
      height 24px
      margin-left 6px
    .font
      color #fff
      font-size 14px
      line-height 1.5
      margin-left 6px
</style>